/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin(value) {
    if (!('Url' in value) || value['Url'] === undefined)
        return false;
    if (!('Identifiers' in value) || value['Identifiers'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Url': json['url'],
        'Identifiers': json['identifiers'],
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['Url'],
        'identifiers': value['Identifiers'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin.js.map